// extracted by mini-css-extract-plugin
export default {"wrapper":"FromPage-module--wrapper--yM57G"};